import React from 'react';
import {
    EBFL2RecordCode,
    EBFL2RecordState,
    TBFL2BackendRecord,
} from '../../../../../redux/app/bfl-2/@types';

import BFL2A1Preview from '../previews/BFL2A1Preview';
import BFL2B1Preview from '../previews/BFL2B1Preview';
import BFL2C1Preview from '../previews/BFL2C1Preview';
import BFL2D1Preview from '../previews/BFL2D1Preview';
import BFL2E1Preview from '../previews/BFL2E1Preview';
import BFL2F1Preview from '../previews/BFL2F1Preview';
import BFL2G1Preview from '../previews/BFL2G1Preview';
import BFL2H1Preview from '../previews/BFL2H1Preview';
import BFL2I1Preview from '../previews/BFL2I1Preview';
import BFL2I2Preview from '../previews/BFL2I2Preview';

import moment from 'moment';
import Biofouling2TableRows from '../BioTableRows';

type OwnProps = {
    biofoulingRecord: TBFL2BackendRecord;
    theme?: "light" | "dark";
};
type Biofouling2PreviewerProps = OwnProps;
function Biofouling2Previewer(props: Biofouling2PreviewerProps) {
    const { biofoulingRecord: record } = props;
    const isStrikedOff = record.state === EBFL2RecordState.STRIKED_OFF;
    const isEditOfApprovedRecord = !!record.dateOfApprovedRecordEdit;

    function renderMain() {
        if (isEditOfApprovedRecord) return renderEditedApprovedRecord();
        return renderRecord(record, isStrikedOff);
    }

    function renderEditedApprovedRecord() {
		if(!record.dateOfApprovedRecordEdit) return null;
        return (
            <>
                {renderEditCorrectionLine()}
                {renderRecord({...record, selectedDate: record.dateOfApprovedRecordEdit}, isStrikedOff)}
                {renderStruckOffVersionOfEdit()}
            </>
        );
    }
    function renderEditCorrectionLine() {
        if (!record.dateOfApprovedRecordEdit) return null;
        const formattedEditDate = moment(
            record.selectedDate,
            'YYYY-MM-DD'
        ).format('DD-MMM-YYYY');

        return (
            <Biofouling2TableRows
                record={record}
                tableRows={[
                    [
                        formattedEditDate,
                        'O',
                        '-',
                        'ENTRY PERTAINING TO AN EARLIER INCORRECT OPERATIONAL ENTRY',
                    ],
                ]}
            />
        );
    }

    function renderStruckOffVersionOfEdit() {
        if (!record.editVersions) return null;
        const oldVersionOfRecord = {
            ...record.editVersions[0],
            state: EBFL2RecordState.STRIKED_OFF,
        };
        return <Biofouling2Previewer biofoulingRecord={oldVersionOfRecord} theme={props.theme} />;
    }

    function renderRecord(
        recordToRender: TBFL2BackendRecord,
        isStrikedOff: boolean = false
    ) {
        switch (recordToRender.recordCode) {
            case EBFL2RecordCode.BFL2A1:
                return (
                    <BFL2A1Preview
                        biofoulingRecord={recordToRender}
                        isStrikedOff={isStrikedOff}
                    />
                );
            case EBFL2RecordCode.BFL2B1:
                return (
                    <BFL2B1Preview
                        biofoulingRecord={recordToRender}
                        isStrikedOff={isStrikedOff}
                    />
                );
            case EBFL2RecordCode.BFL2C1:
                return (
                    <BFL2C1Preview
                        biofoulingRecord={recordToRender}
                        isStrikedOff={isStrikedOff}
                    />
                );
            case EBFL2RecordCode.BFL2D1:
                return (
                    <BFL2D1Preview
                        biofoulingRecord={recordToRender}
                        isStrikedOff={isStrikedOff}
                    />
                );
            case EBFL2RecordCode.BFL2E1:
                return (
                    <BFL2E1Preview
                        biofoulingRecord={recordToRender}
                        isStrikedOff={isStrikedOff}
                    />
                );
            case EBFL2RecordCode.BFL2F1:
                return (
                    <BFL2F1Preview
                        biofoulingRecord={recordToRender}
                        isStrikedOff={isStrikedOff}
                    />
                );
            case EBFL2RecordCode.BFL2G1:
                return (
                    <BFL2G1Preview
                        biofoulingRecord={recordToRender}
                        isStrikedOff={isStrikedOff}
                    />
                );
            case EBFL2RecordCode.BFL2H1:
                return (
                    <BFL2H1Preview
                        biofoulingRecord={recordToRender}
                        isStrikedOff={isStrikedOff}
                    />
                );
            case EBFL2RecordCode.BFL2I1:
                return (
                    <BFL2I1Preview
                        biofoulingRecord={recordToRender}
                        isStrikedOff={isStrikedOff}
                    />
                );

            case EBFL2RecordCode.BFL2I2:
                return (
                    <BFL2I2Preview
                        biofoulingRecord={recordToRender}
                        isStrikedOff={isStrikedOff}
                    />
                );

            default:
                return null;
        }
    }

    return renderMain();
}

export default Biofouling2Previewer;
